﻿import {EventLogGateway} from './eventLog.gateway';
import {EventLogViewModel} from './eventLog.viewmodel';
import * as LogService from "../../core/services/logservice/log.service";
import * as Model from '../../models/models';

export class EventLogController {
    private eventLogViewModel: EventLogViewModel;
    private searchCriteriaModel: Model.IEventLogSearchCriteria;
    private isDataGridLoading: boolean;

    static $inject = ['$uibModal', '$state', 'logService', 'eventLog.gateway', "$scope"];

    constructor(private $modal: any,
        private $state: ng.ui.IStateService,
        private logger: LogService.ILogService,
        private eventLogGateway: EventLogGateway,
        private $scope: any) {
        this.searchCriteriaModel = new Model.EventLogSearchCriteria();
        this.searchCriteriaModel.pagingOptions = new Model.GridPagingOptionsModel();
        this.searchCriteriaModel.sortingOptions = new Model.GridSortingOptionsModel();
        this.activate();
    }

    private activate(): void {
        this.$scope.hasSearchCompleted = false;
        this.$scope.gridOptions = {
            enablePaging: true,
            enableFiltering: false,
            enableGridMenu: true, 
            enablePaginationControls: true,
            flatEntityAccess: true,
            showGridFooter: false,
            fastWatch: true,
            enableHorizontalScrollbar: 0,
            enableColumnResizing: true,
            paginationPageSizes: [25, 50, 75, 100],
            paginationPageSize: 25,
            useExternalPagination: true,
            useExternalSorting: true,
            columnDefs: [
                { name: 'id', displayName: 'ID', enableSorting: true, width: '6%', cellTemplate: '<div class="ui-grid-cell-contents"><a href= "administration/eventLogDetail/{{COL_FIELD}}">{{COL_FIELD}}</a></div>' },
                { name: 'applicationName', displayName: 'APPLICATION', width: '12%', enableSorting: true },
                { name: 'loggerName', displayName: 'LOGGER', width: '11%', enableSorting: true, cellTooltip: true },
                { name: 'eventTime', displayName: 'EVENT TIME', width: '14%', enableSorting: true, cellFilter: 'date:\'MM/dd/yyyy h:mm a\'' },
                { name: 'severity', displayName: 'SEVERITY', width: '10%', enableSorting: true },
                { name: 'activityId', displayName: 'ACTIVITY ID', width: '11%', enableSorting: true, cellTooltip: true },
                { name: 'message', displayName: 'MESSAGE', width: '18%', enableSorting: true, cellTooltip: true },
                { name: 'exception', displayName: 'EXCEPTION', width: '18%', enableSorting: true, cellTooltip: true }
            ],
            onRegisterApi: (gridApi) => {
                this.$scope.gridApi = gridApi;
                this.$scope.gridApi.core.on.sortChanged(this.$scope,
                    (grid, sortColumns) => {
                        if (sortColumns.length === 0) {
                            this.searchCriteriaModel.sortingOptions.columnName = "id";
                            this.searchCriteriaModel.sortingOptions.sortOrder = "asc";
                        }
                        else {
                            this.searchCriteriaModel.sortingOptions.columnName = sortColumns[0].name;
                            this.searchCriteriaModel.sortingOptions.sortOrder = sortColumns[0].sort.direction;
                        }
                        this.search();
                    });
                this.$scope.gridApi.pagination.on.paginationChanged(this.$scope,
                    (newPage, pageSize) => {
                        this.searchCriteriaModel.pagingOptions.pageNumber = newPage;
                        this.searchCriteriaModel.pagingOptions.pageSize = pageSize;
                        this.search();
                    });
            }
        };
        this.loadViewModel();
    }

    private loadViewModel(): ng.IPromise<EventLogViewModel> {
        return this.eventLogGateway.loadViewModel()
            .then((viewModel: EventLogViewModel) => {
                this.eventLogViewModel = viewModel;
                this.ititializePagingOptions();
                this.search();
                return viewModel;
            });
    }

    private submit(): void {
        this.search();
    }

    private next(): void {
        this.searchCriteriaModel.pagingOptions.pageNumber++;
        this.search();
    }

    private prev(): void {
        this.searchCriteriaModel.pagingOptions.pageNumber--;
        this.search();
    }

    private search(): void {
        this.isDataGridLoading = true;

        //if searchResultsGrid is already loaded then clear it so the spinner does not spin on top of data
        if (typeof (this.eventLogViewModel) != "undefined") {
            if (typeof (this.eventLogViewModel.searchResults) != "undefined") {
                this.eventLogViewModel.searchResults = null;
            }
        }

        const eventLogViewModelPromise: ng.IPromise<EventLogViewModel> = this.eventLogGateway.getEventLogs(this.searchCriteriaModel);

        eventLogViewModelPromise.then((eventLogViewModel: EventLogViewModel) => {
            this.$scope.hasSearchCompleted = true;
            this.logger.debug("eventLogViewModelPromise", eventLogViewModel);
            this.eventLogViewModel.searchResults = eventLogViewModel.searchResults;
            this.$scope.gridOptions.totalItems = eventLogViewModel.recordCount;
            this.searchCriteriaModel.pagingOptions.recordCount = eventLogViewModel.recordCount;
            this.searchCriteriaModel.pagingOptions.pageCount =
                Math.ceil(this.searchCriteriaModel.pagingOptions.recordCount /
                    this.searchCriteriaModel.pagingOptions.pageSize);
            this.$scope.gridOptions.data = this.searchCriteriaModel.pagingOptions.recordCount < 1
                ? []
                : eventLogViewModel.searchResults;
            this.isDataGridLoading = false;
        });
    }

    private ititializePagingOptions(): void {
        this.searchCriteriaModel.pagingOptions.pageNumber = 1;
        this.searchCriteriaModel.pagingOptions.pageSize = 25;
    }
}